import React from 'react';
import AriesButton from './AriesButton';

/**
 * AriesTextLinkButton — borderless cyan text link with optional icon (no pill
 * background). Inherits AriesButton behavior and locks the `text-link` variant.
 */
const AriesTextLinkButton = (props) => (
  <AriesButton {...props} variant="text-link" />
);

export default AriesTextLinkButton;
